import {z} from "zod";

export const SENSE_TYPES = ["DARKVISION", "BLINDSIGHT", "TRUESIGHT", "TREMORSENSE"] as const;
export const SENSE_LABELS = {DARKVISION: "Dunkelsicht", BLINDSIGHT: "Blindsicht",
    TRUESIGHT: "Wahre Sicht", TREMORSENSE: "Erschütterungssinn"} as const;
export type SpecialSense = {
    type: typeof SENSE_TYPES[number]; rangeMeters: number;
    blindOutsideRange: boolean; rangeWhenDeafMeters: number | null;
};
export type CharacterSenses = {schemaVersion: 1; passivePerception: number | null;
    specialSenses: SpecialSense[]};
export const emptyCharacterSenses = (): CharacterSenses => ({schemaVersion: 1, passivePerception: null,
    specialSenses: []});
export const newSpecialSense = (): SpecialSense => ({type: "DARKVISION", rangeMeters: 18,
    blindOutsideRange: false, rangeWhenDeafMeters: null});

export const characterSensesSchema = z.object({
    schemaVersion: z.literal(1), passivePerception: z.number().int().nonnegative().nullable(),
    specialSenses: z.array(z.object({type: z.enum(SENSE_TYPES), rangeMeters: z.number().finite().positive(),
        blindOutsideRange: z.boolean(),
        rangeWhenDeafMeters: z.number().finite().positive().nullable(),
    }).superRefine((sense, ctx) => {
        if (sense.blindOutsideRange && sense.type !== "BLINDSIGHT")
            ctx.addIssue({code: "custom", path: ["blindOutsideRange"], message: "Diese Einschränkung gilt nur für Blindsicht"});
        if (sense.rangeWhenDeafMeters !== null && (sense.type !== "BLINDSIGHT" || sense.rangeWhenDeafMeters > sense.rangeMeters))
            ctx.addIssue({code: "custom", path: ["rangeWhenDeafMeters"], message: "Taubheitsreichweite muss innerhalb der Blindsicht liegen"});
    })),
});

export function formatCharacterSenses(senses: CharacterSenses): string[] {
    const values = senses.specialSenses.map(sense => {
        let value = `${SENSE_LABELS[sense.type]} ${sense.rangeMeters.toLocaleString("de-DE")} m`;
        if (sense.rangeWhenDeafMeters != null) value += ` oder ${sense.rangeWhenDeafMeters.toLocaleString("de-DE")} m bei Taubheit`;
        if (sense.blindOutsideRange) value += " (blind außerhalb des Radius)";
        return value;
    });
    if (senses.passivePerception != null) values.push(`Passive Wahrnehmung ${senses.passivePerception}`);
    return values;
}
